<template>
  <div>
    <va-modal
      v-model="showModal"
      id="profileModal"
      ref="profileModal"
      :cancelText="$t('leads.back')"
      size="large"
      :showOkay="false"
      :hideDefaultActions="isMobile"
      @cancel="$emit('cancel')"
      :fixedLayout="true">

      <div slot="header" class="modal-title d-flex justify--space-between">
        <span>{{ `${$t('dashboard_new_evollu.measurements.profile.title')}-${measurementTitle} - ${measurement.created_at}  (${handlePatientName})` }}</span>
      </div>
      <!--<div class="apex-chart-wrapper">
        <apexchart type="line" :series="seriesData" :options="chartOptions"/>
      </div>-->
      <div>
        <ProfileGraph :measurement="measurement"/>
      </div>
    </va-modal>
  </div>
</template>

<script>
import ProfileGraph from "@/components/checkup_plus/patients/ParametersDetails/ProfileGraph.vue";

export default {
  components: {ProfileGraph},
  props: {
    measurement: {
      type: Object,
      required: true
    },
    patientDetails: {
      type: Object,
      required: false
    },
    measurementTitle: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showModal: false,
      lineGraphColors: ['#2596be', '#be2525', '#41be25', '#be5b25', '#be9f25', '#6a25be'],
    }
  },
  mounted() {
    this.showModal = true
  },
  computed: {
    handlePatientName: function () {
      //patientDetails ? `${patientDetails.firstName} ${patientDetails.surname}` : ''
      if (this.patientDetails === null) return ''
      let name = ''
      this.patientDetails.firstName ? name = name.concat(this.patientDetails.firstName) : name = name.concat(this.patientDetails.name)
      if (this.patientDetails.surname) {
        name = name.concat(` ${this.patientDetails.surname}`)
      }
      return name
    },
    isMobile: function () {
      return window.matchMedia(`(max-width: 767px)`).matches || window.matchMedia(`(max-height: 400px)`).matches
    },

  },

}
</script>

<style scoped lang="scss">


.chart-wrapper {
  width: 2200px;
  height: 400px;
  margin-bottom: 0.4rem;
  overflow-x: scroll;

}
</style>
